import React from "react"
import Tooltip from "@material-ui/core/Tooltip"
import PropType from "prop-types"

const CustomTooltips = props => {
	const { content, children } = props
	return (
		<Tooltip
			title={
				<div style={{ fontSize: "1.2em", fontFamily: "Noto Sans, sans-serif" }}>
					{content}
				</div>
			}
			{...props}
		>
			{children}
		</Tooltip>
	)
}

CustomTooltips.propTypes = {
	content: PropType.string
}

export default CustomTooltips
